if (!customElements.get('variant-pills')) {
  customElements.define(
    'variant-pills',
    class VariantPills extends HTMLElement {
      connectedCallback() {
        this.pills = [...this.querySelectorAll('.variant-pill[data-variant-id]')];
        this.pills.forEach((pill) => {
          pill.addEventListener('click', this.onPillClick.bind(this));
        });
      }

      onPillClick(event) {
        const pill = event.currentTarget;
        if (this.classList.contains('loading')) return;

        const variantId = pill.dataset.variantId;
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfigForCartAdd('javascript');

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (cart) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        this.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof publish !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'variant-pills',
                  productVariantId: variantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
              }
              return;
            }
            if (cart) cart.renderContents(response);
            if (typeof publish !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'variant-pills',
                productVariantId: variantId,
                cartData: response,
              });
            }
            pill.classList.add('variant-pill--added');
            window.setTimeout(() => pill.classList.remove('variant-pill--added'), 1500);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}
